<template>
  <div class="w-full">
    <SparkInput
      name="text-category-filter"
      :label="label"
      v-model="filterValue"
      :placeholder="`Enter ${label.toLowerCase()}`"
    />
    <div
      v-if="filterValue"
      class="text-11 text-primary-600 cursor-pointer hover:text-primary-700 mt-2 text-right"
      @click="clear()"
    >
      Clear
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import SparkInput from '@/components/SparkComponents/SparkInput.vue';

export default {
  name: 'TextCategoryFilter',

  components: {
    SparkInput,
  },

  props: {
    reset: Number,
    label: String,
    component: String,
    parent: String,
  },

  emits: ['selected'],

  data() {
    return {
      filterValue: '',
    };
  },

  computed: {
    ...mapState(['partLibraryFilters', 'user', 'organization']),

    textCategories() {
      return this.organization.text_categories;
    },
  },

  watch: {
    filterValue(newVal) {
      let uid = this.getCategoryUid(this.label);
      this.$emit('selected', { text_categories: { [uid]: newVal } });
      if (newVal === '') {
        this.resetFilter({
          text_categories: uid,
        });
      }
    },

    reset: {
      handler(reset) {
        if (reset) {
          this.remove();
          this.selectedCategories = [];
        }
      },
    },
  },

  mounted() {
    if (this.parent === 'library') {
      let value = this.partLibraryFilters.text_categories[this.getCategoryUid(this.label)];
      if (value != undefined) {
        this.filterValue = value;
      }
    }
  },

  methods: {
    ...mapMutations(['resetFilter', 'disablePartLibraryFilter']),

    remove() {
      this.disablePartLibraryFilter({
        [this.label]: this.component,
      });
      this.clear();
    },

    getCategoryUid(categoryName) {
      let categoryUid = '';
      Object.keys(this.textCategories).forEach(uid => {
        if (this.textCategories[uid].label === categoryName) {
          categoryUid = uid;
        }
      });
      return categoryUid;
    },

    clear() {
      this.resetFilter({
        text_categories: this.getCategoryUid(this.label),
      });
      this.filterValue = '';
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
